import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';

const loginModule = () => import('./login/login.component').then((x) => x.LoginComponent)
const dashboardModule = () => import('./dashboard/dashboard.module').then(x => x.DashboardModule);
const Apartment = () => import('./apartment/aprtment.module').then(x => x.ApartmentModule)
const laundry = () => import('./laundry/lundry.module').then(x => x.LaundryModule)
const restaurant = () => import('./restaurant-management/restaurant-management.module').then(x => x.RestaurantManagementModule)
const grocery = () => import('./grocery-management/grocery-management.module').then(x => x.GroceryManagementModule)
const UploadBanner = () => import('./main-banner-image/main-banner-image.module').then(x => x.MainBannerModule)
const settingModule = () => import('./settings/settings.module').then(x => x.SettingModule)
const QRCodeModule = () => import('./qr-code/qr-code.module').then(x => x.QRCodeModule)
const OrderDetailsModule = () => import('./order-details/order-details.module').then(x => x.OrderDetailsModule)
const staffModule = () => import('./staff-creation/staff-creation.module').then(x => x.StaffCreationModule)
const TaxModule = () => import('./tax-module/tax-module.module').then(x => x.TaxModuleModule)
const LaundryReportModule = () => import('./Report/laundry-report-generation/laundry-report-generation.module').then(x => x.LaundryReportGenerationModule)
const RestaurantReportModule = () => import('./Report/food-report-generation/food-report-generation.module').then(x => x.FoodReportGenerationModule)
const RoomServiceReportModule = () => import('./Report/room-serice-report-generation/room-serice-report-generation.module').then(x => x.RoomSericeReportGenerationModule)
const ResidentialReportModule = () => import('./Report/residential-report-generation/residential-report-generation.module').then(x => x.ResidentialReportGenerationModule)
const ClubReportModule = () => import('./Report/club-report-generation/club-report-generation.module').then(x => x.ClubReportGenerationModule)
const FAQModule = () => import('./FAQ/feedback-questions/feedback-questions.module').then(x => x.FeedbackQuestionsModule)
const FAQCategoryModule = () => import('./FAQ/faq-category/faq-category.module').then(x => x.FaqCategoryModule)
const AllOrdersModule = () => import('./all-orders/all-orders.module').then(x => x.AllOrdersModule)

const foodOrderModule = () => import('./food-orders-details/food-orders-details.module').then(x => x.FoodOrdersModule)
const roomOrderModule = () => import('./room-order-details/room-order-details.module').then(x => x.RoomOrderDetailsModule)
const ResidentialOrderModule = () => import('./residential-order-details/residential-order-details.module').then(x => x.ResidentialOrderDetailsModule)
const AdditionalOrderModule = () => import('./additional-order-details/additional-order-details.module').then(x => x.AdditionalOrderDetailsModule)
const ClubOrderModule = () => import('./club-order-details/club-order-details.module').then(x => x.ClubOrderDetailsModule)
const NotificationModule = () => import('./notification/notification.module').then(x => x.NotificationModule)
const AdminNotifcationModule = () => import('./user-admin-send-notification/user-admin-send-notification.module').then(x => x.UserAdminSendNotificationModule)

const EmergencyNotification = () => import('./emergency-notification/emergency-notification.module').then(x => x.EmergencyNotificationModule)
const SavedAlertModule = () => import('./emergency-notification/saved-alert/saved-alert.module').then(x => x.SavedAlertModule)
const AlertResponseModule = () => import('./emergency-notification/alert-response/alert-response.module').then(x => x.AlertResponseModule)
const ActiveAlertModule = () => import('./emergency-notification/active-alert/active-alert.module').then(x => x.ActiveAlertModule)
const AlertHistroyModule = () => import('./emergency-notification/alert-history/alert-history.module').then(x => x.AlertHistoryModule)
const AlertReportModule = () => import('./emergency-notification/alert-report/alert-report.module').then(x => x.AlertReportModule)
const FloorMappingModule = () => import('./emergency-notification/floor-mapping/floor-mapping.module').then(x => x.FloorMappingModule)
const Club = () => import('./club/club.module').then(x => x.ClubModule)
const CarRental = () => import('./car-rental/car-rental.module').then(x => x.CarRentalModule)
const Adventure = () => import('./adventure/adventure.module').then(x => x.AdventureModule)
const Spa = () => import('./spa/spa.module').then(x => x.SpaModule)
const WalletModule = () => import('./wallet/wallet.module').then(x => x.WalletModule)
const RatingModule = () => import('./ratings/ratings.module').then(x => x.RatingsModule)
const AuditLogModule = () => import('./audit-logs/audit-logs.module').then(x => x.AuditLogModule)

const routes: Routes = [
  {
    path: 'login',
    loadComponent: loginModule
  },

  {
    path: 'dashboard',
    loadChildren: dashboardModule,
    canActivate: [AuthGuard]
  },

  {
    path: 'apartment',
    loadChildren: Apartment,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry',
    loadChildren: laundry,
    canActivate: [AuthGuard]
  },
  {
    path: 'restaurant',
    loadChildren: restaurant,
    canActivate: [AuthGuard]
  },
  {
    path: 'grocery',
    loadChildren: grocery,
    canActivate: [AuthGuard]
  },
  {
    path: 'club',
    loadChildren: Club,
    canActivate: [AuthGuard]
  },
  {
    path: 'car-rental',
    loadChildren: CarRental,
    canActivate: [AuthGuard]
  },
  {
    path: 'adventure',
    loadChildren: Adventure,
    canActivate: [AuthGuard]
  },
  {
    path: 'spa',
    loadChildren: Spa,
    canActivate: [AuthGuard]
  },
  {
    path: 'upload-banner',
    loadChildren: UploadBanner,
    canActivate: [AuthGuard]
  },
  {
    path: 'setting',
    loadChildren: settingModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'qr-code',
    loadChildren: QRCodeModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-detail',
    loadChildren: OrderDetailsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'staff',
    loadChildren: staffModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'tax',
    loadChildren: TaxModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-report',
    loadChildren: LaundryReportModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'restaurant-report',
    loadChildren: RestaurantReportModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'room-service-report',
    loadChildren: RoomServiceReportModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'residential-report',
    loadChildren: ResidentialReportModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'club-report',
    loadChildren: ClubReportModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'feedback',
    loadChildren: FAQModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'FAQ-category',
    loadChildren: FAQCategoryModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'all-orders',
    loadChildren: AllOrdersModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-order-details',
    loadChildren: foodOrderModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'room-order-details',
    loadChildren: roomOrderModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'residential-order-details',
    loadChildren: ResidentialOrderModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'additional-order-details',
    loadChildren: AdditionalOrderModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'club-order-details',
    loadChildren: ClubOrderModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'car-rental-order-details',
    loadComponent: () => import('./car-rental-order-details/car-rental-order-details.component').then(x => x.CarRentalOrderDetailsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'grocery-order-details',
    loadComponent: () => import('./grocery-order-details/grocery-order-details.component').then(x => x.GroceryOrderDetailsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'notification',
    loadChildren: NotificationModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'admin-notification',
    loadChildren: AdminNotifcationModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'emergency-notification',
    loadChildren: EmergencyNotification,
    canActivate: [AuthGuard]
  },
  {
    path: 'active-alert',
    loadChildren: ActiveAlertModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'alert-response',
    loadChildren: AlertResponseModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'alert-history',
    loadChildren: AlertHistroyModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'alert-report',
    loadChildren: AlertReportModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'saved-alert',
    loadChildren: SavedAlertModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'floor-mapping',
    loadChildren: FloorMappingModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'wallet',
    loadChildren: WalletModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'ratings',
    loadChildren: RatingModule,
    canActivate: [AuthGuard]
  },
    {
    path: 'audit-logs',
    loadChildren: AuditLogModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./onboarding/onboarding.component').then(x => x.OnboardingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'onboarding/:id',
    loadComponent: () => import('./onboarding/onboarding-detail/onboarding-detail.component').then(x => x.OnboardingDetailComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin-logs',
    loadComponent: () => import('./admin-logs/admin-logs.component').then(x => x.AdminLogsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'user-alerts',
    loadComponent: () => import('./user-alerts/user-alerts.component').then(x => x.UserAlertsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'vendor-settlement',
    loadComponent: () => import('./vendor-settlement/vendor-settlement.component').then(x => x.VendorSettlementComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'support-panel',
    loadComponent: () => import('./support-panel/support-panel.component').then(x => x.SupportPanelComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'translations',
    loadComponent: () => import('./translations/translations.component').then(x => x.TranslationsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'coupon',
    loadComponent: () => import('./coupon/coupon.component').then(x => x.CouponComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'coupon/add-coupon',
    loadComponent: () => import('./coupon/add-coupon/add-coupon.component').then(x => x.AddCouponComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'owner',
    loadComponent: () => import('./owner/owner.component').then(x => x.OwnerComponent),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
